import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { requestForToken, onMessageListener } from "./firebase";
import { useExtraFieldsContext } from "../contexts/ExtraFieldsContext";

const Notification = () => {
  const { setExtraFields } = useExtraFieldsContext();
  const [notification, setNotification] = useState({ title: "", body: "" });
  const notify = () => toast(<ToastDisplay />);
  function ToastDisplay() {
    return (
      <div>
        <p>
          <b>{notification?.title}</b>
        </p>
        <p>{notification?.body}</p>
      </div>
    );
  }

  useEffect(() => {
    if (notification?.title) {
      notify();
    }
  }, [notification]);

  requestForToken();

  onMessageListener()
    .then((payload) => {
      let payloadObj = JSON.parse(payload?.data?.payload);
      let getUserId = localStorage.getItem("userId");
      let getUserRole = localStorage.getItem("roleEmployee");
      let raiseNotification = false;
      for (const val of payloadObj.notificationFor) {
        if (val === "ALL_USERS" && getUserRole === "employee") {
          raiseNotification = true;
        }
      }

      let IndexOf = payloadObj.users.indexOf(getUserId);
      if (IndexOf >= 0) {
        raiseNotification = true;
      }

      if (raiseNotification) {
        setNotification({
          title: payload?.notification?.title,
          body: payload?.notification?.body,
        });
        setExtraFields((prev) => ({
          ...prev,
          newNotificationCount: Number(prev.newNotificationCount + 1),
        }));
      }
    })
    .catch((err) => console.log("failed: ", err));

  return <Toaster />;
};

export default Notification;
